import { FC } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MdUpdate } from 'react-icons/md'
import { InquiryStatusMap, MiInquiry } from '../../../models/inquiriesModel'
import { fmtDate, fmtDateTime } from '../../../util/date'

type ListInquiryProps = {
  inquiry: MiInquiry
  collapsed: boolean
}

export const ListInquirySection: FC<ListInquiryProps> = ({ inquiry, collapsed }) => {
  if (collapsed) {
    return <></>
  }

  return (
    <Row className="panel">
      <Col xs={12} sm={6} className="cell">
        <div className="label">申請日</div>
        <div className="detailContent">
          <div className="text">{fmtDate(inquiry.createdAt)}</div>
        </div>
      </Col>
      <Col xs={12} sm={6} className="cell">
        <div className="label">ステータス</div>
        <div className="detailContent">
          <div className="text">{InquiryStatusMap[inquiry.status]}</div>
        </div>
      </Col>
      <div className="meta">
        <div>
          <MdUpdate /> {fmtDateTime(inquiry.updatedAt)}
        </div>
        <div>{inquiry.id}</div>
      </div>
    </Row>
  )
}
